import { TotalMarginQuery } from './totalMarginQuery';

export class ContributionMarginQuery extends TotalMarginQuery {
  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged = false) {
    super(pointOfSaleGuid, dateStart, dateEnd, isManaged);
    if (isManaged) {
      this.cuts.push({ expression: "sale_rate_is_managed = '1'" });
    }
  }
}
